import { useMemo } from 'react';
import { products } from '@/mocks/products';
import ProductCard from './ProductCard';
import Reveal from '@/components/base/Reveal';
import { useCatalogVersion } from '@/lib/catalogStore';

export default function ProductShowcase() {
  const version = useCatalogVersion();
  const popular = useMemo(
    () =>
      [...products]
        .sort((a, b) => (b.sales - a.sales) || (b.rating - a.rating))
        .slice(0, 12),
    [version],
  );

  return (
    <section id="featured" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <Reveal>
          <div>
            <span className="text-xs font-mono uppercase tracking-[0.25em] text-primary-500 whitespace-nowrap">
              popular
            </span>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-normal tracking-tight text-white">
              인기상품
            </h2>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {popular.length > 0
            ? popular.map((product, index) => (
                <Reveal key={product.id} delay={(index % 4) * 60}>
                  <ProductCard product={product} />
                </Reveal>
              ))
            : Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="aspect-square rounded-2xl bg-white/5 animate-pulse" />
              ))}
        </div>
      </div>
    </section>
  );
}
